module.exports = __webpack_public_path__ + "static/img/IMG_20170908_122004.ce2d35dd.jpg";